import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import api from "../../../../../../api/api";
import {
  alert_image,
  graduation,
  Teacher_Dashboard_Default,
  dashborad_Courses_book_image,
  Asset_teacher,
  Asset_teacher2,
  sync_with_cshoology,
  revenue_image,
  warning_blue_img,
} from "../../../../../../assets/images/images";
import { updateGlobalState } from "../../../../../../state/global/slice";
import AOS from "aos";
import "aos/dist/aos.css";
import CreateCourse from "../course/CreateCourse";
import Card from "../course/Card";
import { toast } from "react-toastify";
import MyCourses from "./MyCourses";
import { useNavigate } from "react-router";
import { CircularProgress, Grid } from "@mui/material";
import { getAllCoursesByTeacherId } from "../../../../../../state/actions/getAllCoursesByTeacherIdAction";
import FitText from "../Tab/FitText"
import Loader from "../../../../../../components/FileRepo/Components/Loader";

const TeacherHome = ({
  handlePageChange,
  totalPages,
  currentPage,
  nextUrl,
  prevUrl,
  showCourse,
  setShowCourse,
  toggleCourse,
  getDashboardCount,
  courseLoading,
  setgetDashboardCount,
  dashboardCountLoading,
  setdashboardCountLoading,
}) => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [deleteCourse, setdeleteCourse] = useState(false);
  const [archiveCourse, setArchiveCourse] = useState(false);
  const [archiveLoading, setArchiveLoading] = useState(false);
  const [archiveAction, setArchiveAction] = useState({
      courseId: null,
      isArchived: false,
    });
  const [pendingArchives, setPendingArchives] = useState({});
  const globalState = useSelector((state) => state.globalState);
  const dispatch = useDispatch();
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };
  const [loading, setLoading] = useState(false);

  const toggleDeleteCourse = () => {
    setdeleteCourse(!deleteCourse);
    setLoading(false);
    document.body.style.overflow = "auto";
  };

/*  const toggleArchiveCourse = (courseId = null, isArchived = false) => {
   setArchiveAction({ courseId, isArchived });
   setArchiveCourse(true);
   setArchiveLoading(false);
   document.body.style.overflow = "hidden";
 }; */
const toggleArchiveCourse = (course) => {
  setArchiveAction({
    courseId: course.course_id,
    isArchived: course.is_archived,
  });

  setSelectedCourse(course.name);

  setArchiveCourse(true);
  setArchiveLoading(false);

  document.body.style.overflow = "hidden";
};

const executeArchive = async (course) => {
  const courseId = course.course_id;

  try {
    const response = await api.post(
      `/courses/${courseId}/archive/`,
      {
        is_archived: !course.is_archived,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );

    if (response.status === 200) {
      dispatch(
        getAllCoursesByTeacherId(
          currentPage,
          teacher_id,
          token
        )
      );

      toast.success(
        <div>
          <div className="font-bold">
            {course.is_archived
              ? "Course Restored Successfully"
              : "Course Archived Successfully"}
          </div>

          <div className="mt-1">
            {course.is_archived ? (
              <>
                “{course.name}” has been moved back to
                Active Courses
              </>
            ) : (
              <>
                You can access the archived course,
                “{course.name},” from the Total
                Courses → Archive tab.
              </>
            )}
          </div>
        </div>,
        {
          containerId: "archive-toast",
        }
      );
    } else {
      toast.error(
        "Something went wrong. Please Try Again",
        {
          position: "top-center",
        }
      );
    }
  } catch (error) {
    toast.error("Something went wrong.", {
      position: "top-center",
    });
  }

  setPendingArchives((prev) => {
    const updated = { ...prev };
    delete updated[courseId];
    return updated;
  });
};
const undoArchive = (courseId) => {
  const pending = pendingArchives[courseId];

  if (!pending) return;

  clearTimeout(pending.timeoutId);

  setPendingArchives((prev) => {
    const updated = { ...prev };
    delete updated[courseId];
    return updated;
  });

  toast.success("Archive cancelled");
};

 const closeArchiveModal = () => {
  setArchiveCourse(false);
  setArchiveLoading(false);
  document.body.style.overflow = "auto";
};
  const teacher_id = globalState?.teacher_details?.data?.teacher_id;

  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }
  const [selectedCourse, setSelectedCourse] = useState(null);

  // Handle file input
  const deleteCourseId = async () => {
    setLoading(true);
    document.body.style.overflow = "auto";
    try {
      const response = await api.delete(
        `/courses/delete-course/${selectedCourse}/`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        },
      );
      if (response.data.status === 200) {
        setdashboardCountLoading(true);
        api
          .get("/auth/teacher-dashboard-count/", {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              if (response?.data) {
                setdashboardCountLoading(false);
                setgetDashboardCount(response?.data);
              }
            }
          })
          .catch((error) => {
            setdashboardCountLoading(false);
          });
        dispatch(getAllCoursesByTeacherId(currentPage, teacher_id, token));

        setLoading(false);

        const course_list = globalState.course_list?.filter(
          (course) => course.course_id !== selectedCourse,
        );
        updateState("course_list", course_list);

        setTimeout(() => {
          setdeleteCourse(false);
          toast.success("Course deleted successfully.", {
            position: "top-center",
          });
        }, 700);
      } else {
        setLoading(false);
        setdeleteCourse(false);
        toast.error("Something went wrong.", {
          position: "top-center",
        });
      }
    } catch (error) {
      setLoading(false);
      setdeleteCourse(false);
    }
  };
/*   const handleArchiveCourse = async () => {
    const { courseId, isArchived } = archiveAction;
    if(!courseId) return;
    setArchiveLoading(true);
    document.body.style.overflow = "auto";
    try {
      const response = await api.post(
        `/courses/${courseId}/archive/`,
        {is_archived: !isArchived},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setArchiveLoading(false);
        const course_list = globalState.course_list?.map((course) =>
          course.course_id === courseId ? { ...course, is_archived: isArchived } : course
        );
        updateState("course_list", course_list);
        dispatch(getAllCoursesByTeacherId("1", teacher_id, token));

          toast.success(
            <div>
              <div className="font-bold">
                {isArchived
                  ? "Course Restored Successfully"
                  : "Course Archived Successfully"}
              </div>

              <div className="mt-1">
                {isArchived ? (
                  <>“{selectedCourse}” has been moved back to Active Courses</>
                ) : (
                  <>
                    You can access the archived course, “{selectedCourse},” from
                    the Total Courses → Archive tab.
                  </>
                )}
              </div>
            </div>,
            {
              containerId: "archive-toast",
            },
          );
        setTimeout(() => {
          setArchiveCourse(false);
        }, 700);
      } else {
        setArchiveLoading(false);
        setArchiveCourse(false);
        toast.error("Something went wrong. Please Try Again", {
          position: "top-center",
        });
      }
    } catch (error) {
      setArchiveLoading(false);
      setArchiveCourse(false);
      toast.error("Something went wrong.", {
        position: "top-center",
      });
    }
  }; */
  const handleArchiveCourse = async () => {
  const { courseId } = archiveAction;

  if (!courseId) return;

  const course = globalState.course_list?.find(
    (c) => c.course_id === courseId
  );

  if (!course) return;

  setArchiveCourse(false);
  document.body.style.overflow = "auto";

  const expiresAt = Date.now() + 5000;

  const timeoutId = setTimeout(async () => {
    await executeArchive(course);
  }, 5000);

  setPendingArchives((prev) => ({
    ...prev,
    [courseId]: {
      timeoutId,
      expiresAt,
    },
  }));
};
  useEffect(() => {
    AOS.init({
      duration: 500,
    });
  }, []);

  const handleSchoology = () => {
    if (!dashboardCountLoading) {
      // if (getDashboardCount?.data?.total_schoology_courses > ) {
      navigate(`/sync-with-schoology`);
    }
    // }
  };
  useEffect(() => {
  const handleVisibilityChange = async () => {
    if (document.hidden) {
      const pendingEntries = Object.entries(pendingArchives);

      for (const [courseId, value] of pendingEntries) {
        clearTimeout(value.timeoutId);

        const course = globalState.course_list?.find(
          (c) => c.course_id === Number(courseId)
        );

        if (course) {
          await executeArchive(course);
        }
      }
    }
  };

  document.addEventListener(
    "visibilitychange",
    handleVisibilityChange
  );

  return () => {
    document.removeEventListener(
      "visibilitychange",
      handleVisibilityChange
    );
  };
}, [pendingArchives, globalState.course_list]);
  return (
    <>
      <div className="dashboard-main-section">
        <h2 className="dashboard-name-title">
          Hello {globalState?.teacher_details?.data?.name}!
        </h2>
        <div className="dashborad-Courses-container">
          <div
            className="dashborad-Courses-folder flex-row"
            style={{ cursor: dashboardCountLoading ? "progress" : "pointer" }}
            onClick={
              dashboardCountLoading
                ? () => {}
                : () =>
                    getDashboardCount?.data?.total_courses > 0
                      ? navigate(`/course-list`, {
                          state: { totalPages: totalPages },
                        })
                      : toggleCourse("hidden")
            }
          >
            <div className="dashborad-Courses-folder-image">
              <img src={dashborad_Courses_book_image} alt="" />
            </div>
            <div className="dashborad-Courses-count">
              <h2>{getDashboardCount?.data?.total_courses || 0}</h2>
              <p>
                {getDashboardCount?.data?.total_courses > 1
                  ? " Total Courses"
                  : " Total Course"}{" "}
              </p>
            </div>
          </div>
          <div
            className="dashborad-Courses-folder flex-row"
            style={{ cursor: dashboardCountLoading ? "progress" : "pointer" }}
            onClick={
              dashboardCountLoading
                ? () => {}
                : () =>
                    getDashboardCount?.data?.total_courses > 0
                      ? navigate(`/lesson-list`)
                      : toggleCourse("hidden")
            }
          >
            <div className="dashborad-Courses-folder-image">
              <img
                src={Asset_teacher2}
                className="asset_book_image teacher-dash-img"
                alt=""
              />
            </div>
            <div className="dashborad-Courses-count">
              <h2>{getDashboardCount?.data?.total_lessons || 0}</h2>
              <p>
                {" "}
                {getDashboardCount?.data?.total_lessons > 1
                  ? "Total Lessons"
                  : "Total Lesson"}{" "}
              </p>
            </div>
          </div>
          <div
            className="dashborad-Courses-folder flex-row"
            style={{ cursor: dashboardCountLoading ? "progress" : "pointer" }}
            onClick={
              dashboardCountLoading
                ? () => {}
                : () =>
                    getDashboardCount?.data?.total_courses > 0
                      ? navigate(`/assignment-list`)
                      : toggleCourse("hidden")
            }
          >
            <div className="dashborad-Courses-folder-image teacher-dash-img-cont">
              <img src={Asset_teacher} className="!h-[50px]" alt="" />
            </div>
            <div className="dashborad-Courses-count">
              <h2>{getDashboardCount?.data?.total_assignments || 0}</h2>
              <p>
                {" "}
                {getDashboardCount?.data?.total_assignments > 1
                  ? "Total Assignments"
                  : "Total Assignment"}
              </p>
            </div>
          </div>
          <div
            className="dashborad-Courses-folder flex-row"
            style={{ cursor: dashboardCountLoading ? "progress" : "pointer" }}
            onClick={
              dashboardCountLoading
                ? () => {}
                : () =>
                    getDashboardCount?.data?.total_courses > 0
                      ? navigate(`/studnet-list`)
                      : toggleCourse("hidden")
            }
          >
            <div className="dashborad-Courses-folder-image teacher-dash-img-cont">
              <img
                src={graduation}
                alt=""
                className="teacher-dash-img !h-[50px]"
              />
            </div>
            <div className="dashborad-Courses-count">
              <h2>{getDashboardCount?.data?.enrolled_students_count || 0}</h2>
              <p>
                {getDashboardCount?.data?.enrolled_students_count > 1
                  ? "Total Students"
                  : "Total Student"}
              </p>
            </div>
          </div>
          {/* <div className="dashborad-Courses-folder"
            style={{ cursor: dashboardCountLoading ? "progress" : "pointer" }}
            onClick={() => handleSchoology()}>
            <div className="dashborad-Courses-folder-image">
              <img src={sync_with_cshoology} alt="" className="sync_with_cshoology" />
            </div>
            <div className="dashborad-Courses-count">
              <h2>{getDashboardCount?.data?.total_schoology_courses}</h2>
              <p>
                Schoology
              </p>
            </div>
          </div> */}
          {globalState.enabled_modules?.includes("marketplace") && (
            <div
              className="dashborad-Courses-folder flex-row"
              style={{ cursor: dashboardCountLoading ? "progress" : "pointer" }}
              onClick={() => {
                if (!dashboardCountLoading) navigate(`/revenue-details`);
              }}
            >
              <div className="dashborad-Courses-folder-image">
                <img
                  src={revenue_image}
                  alt=""
                  className="sync_with_cshoology"
                />
              </div>
              <div className="dashborad-Courses-count">
                <FitText maxFontSize={22} minFontSize={8}>
                  {getDashboardCount?.data?.currency_symbol ?? ""}
                  {new Intl.NumberFormat("en-IN").format(
                    isNaN(Number(getDashboardCount?.data?.total_earnings))
                      ? 0
                      : Number(getDashboardCount?.data?.total_earnings),
                  )}
                </FitText>
                <p>My Earnings</p>
              </div>
            </div>
          )}
        </div>
        <div className="Start-by-creating-your-course-container">
          <p>Start by creating your course</p>
          <button type="button" onClick={() => toggleCourse("hidden")}>
            Create Course
          </button>
        </div>
        {/* <h2 className="overall-performance-analytics-title">Analytics</h2> */}
        {/* <OverallPerformanceDashboard/> */}

        <div className="created-my-courses-wrapper">
          {/* {totalPages > 1 && <h2 className="my-course-title">My Courses</h2>} */}
          {getDashboardCount?.data?.total_courses > 1 && (
            <h2 className="my-course-title">My Courses</h2>
          )}

          {globalState?.course_list === null ||
          globalState?.course_list?.length === 0 ? (
            <>
              <Card
                image={Teacher_Dashboard_Default}
                title="Craft an Interactive Course"
                description="Crafting an interactive course involves designing engaging lessons with quizzes and activities to actively involve students in the learning process"
              />
              <Card
                image={Teacher_Dashboard_Default}
                title="Build an Exciting Learning Journey"
                description="Crafting an interactive course involves designing engaging lessons with quizzes and activities to actively involve students in the learning process"
              />
            </>
          ) : courseLoading ? (
            <Grid
              height={"50vh"}
              xs={12}
              container
              justifyContent={"center"}
              alignItems={"center"}
            >
              <CircularProgress size={80} />
            </Grid>
          ) : (
            <MyCourses
              setSelectedCourse={setSelectedCourse}
              toggleDeleteCourse={toggleDeleteCourse}
              toggleArchiveCourse={toggleArchiveCourse}
              pendingArchives={pendingArchives}
              undoArchive={undoArchive}
              nextUrl={nextUrl}
              prevUrl={prevUrl}
              handlePageChange={handlePageChange}
              totalPages={totalPages}
              currentPage={currentPage}
            />
          )}
        </div>

        {deleteCourse && (
          <form action="" className="delete-course-form">
            <div className="delete-course-form-container" data-aos="zoom-in">
              <div className="delete-course-alert-image">
                <img src={alert_image} alt="" />
              </div>
              <h2>Are you sure you want to delete this course?</h2>
              <div className="delete-course-form-btn-folder">
                <button
                  type="button"
                  onClick={toggleDeleteCourse}
                  className="not-delete-btn"
                >
                  No
                </button>
                {loading ? (
                  <div className="loading-spinner" />
                ) : (
                  <button
                    type="button"
                    onClick={deleteCourseId}
                    disabled={loading}
                    className="delete-btn"
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
          </form>
        )}
        {archiveCourse && (
          <form action="" className="delete-course-form">
            <div
              className="delete-course-form-container relative"
              data-aos="zoom-in"
            >
             {/*  {archiveLoading && (
                <div className="absolute inset-0 z-50 flex items-center justify-center bg-white rounded-xl">
                  <Loader />
                </div>
              )} */}

              <div className="delete-course-alert-image">
                <img src={warning_blue_img} alt="" />
              </div>

              <h2>
                Are you sure you want to{" "}
                {archiveAction.isArchived ? "unarchive" : "archive"} this
                course?
              </h2>

              <div className="delete-course-form-btn-folder">
                <button
                  type="button"
                  onClick={closeArchiveModal}
                  disabled={archiveLoading}
                  className="border-[#0068FF] bg-white text-[#0068FF]"
                >
                  No
                </button>

                <button
                  type="button"
                  onClick={handleArchiveCourse}
                  disabled={archiveLoading}
                  className="border-[#0068FF] text-white bg-[#0068FF]"
                >
                  {archiveAction.isArchived ? "Unarchive" : "Archive"}
                </button>
              </div>
            </div>
          </form>
        )}

        {/* Course created form start */}
        {showCourse && (
          <CreateCourse
            setShowCourse={setShowCourse}
            toggleCourse={toggleCourse}
          />
        )}
      </div>
    </>
  );
};

export default TeacherHome;
